import React from 'react'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEnvironmentContext } from 'contexts/EnvironmentContext'
import { initPostHog, isPostHogEnabled } from 'utils/PostHog/posthog'
import posthog from 'posthog-js'

/**
 * Wraps children with PostHogProvider only when running in a develop environment.
 * Uses the preflight Environment enum, falling back to hostname check.
 */
export const PostHogProviderWrapper: React.FC = ({ children }) => {
  const { environment } = useEnvironmentContext()
  const [initialized, setInitialized] = React.useState(false)

  React.useEffect(() => {
    if (environment && !initialized && isPostHogEnabled(environment)) {
      initPostHog(environment)
      setInitialized(true)
    }
  }, [environment, initialized])

  if (initialized) {
    return <PHProvider client={posthog}>{children}</PHProvider>
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
